import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppWithAuthContext } from 'global/App';

import 'styles';

ReactDOM.render(<AppWithAuthContext />, document.getElementById('root'));
